import React from 'react';

const isLocalDev = process.env.NODE_ENV === 'development';

export const Static = () => (
  <>
    <meta charSet="utf-8" />
    {!isLocalDev && (
      <link rel="manifest" href="/static/assets/favicon/manifest.json" />
    )}
    <meta httpEquiv="X-UA-Compatible" content="IE=edge, chrome=1" />
    <meta httpEquiv="content-type" content="text/html; charset=utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <meta name="theme-color" content="#ffffff" />
    <meta name="msapplication-TileColor" content="#da532c" />
    <meta
      name="msapplication-TileImage"
      content="https://www.johnlewis.com/static/assets/favicon/mstile-144x144.png"
    />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:site" content="@JLandPartners" />
    <meta
      name="apple-itunes-app"
      content="app-id=486502369, app-argument=m.johnlewis.com"
    />
    <meta name="apple-mobile-web-app-capable" content="yes" />
    <meta name="apple-mobile-web-app-title" content="Standard PLP" />
    <meta name="apple-mobile-web-app-status-bar-style" content="default" />

    <link
      rel="mask-icon"
      href="https://www.johnlewis.com/static/assets/favicon.svg"
      color="#000000"
    />
    <link
      rel="shortcut icon"
      type="image/x-icon"
      href="https://www.johnlewis.com/static/assets/favicon/favicon.ico"
    />
    <link
      rel="apple-touch-icon"
      href="https://www.johnlewis.com/static/assets/favicon/apple-touch-icon.png"
      sizes="180x180"
    />
    <link
      rel="icon"
      href="https://www.johnlewis.com/static/assets/favicon/favicon-16x16.png"
      sizes="16x16"
    />
    <link
      rel="icon"
      href="https://www.johnlewis.com/static/assets/favicon/favicon-32x32.png"
      sizes="32x32"
    />
    <link
      rel="icon"
      href="https://www.johnlewis.com/static/assets/favicon/android-chrome-36x36.png"
      sizes="36x36"
    />
    <link
      rel="icon"
      href="https://www.johnlewis.com/static/assets/favicon/android-chrome-48x48.png"
      sizes="48x48"
    />
    <link
      rel="icon"
      href="https://www.johnlewis.com/static/assets/favicon/android-chrome-72x72.png"
      sizes="72x72"
    />
    <link
      rel="icon"
      href="https://www.johnlewis.com/static/assets/favicon/android-chrome-96x96.png"
      sizes="96x96"
    />
    <link
      rel="icon"
      href="https://www.johnlewis.com/static/assets/favicon/android-chrome-144x144.png"
      sizes="144x144"
    />
    <link
      rel="icon"
      href="https://www.johnlewis.com/static/assets/favicon/android-chrome-192x192.png"
      sizes="192x192"
    />
    <link
      rel="icon"
      href="https://www.johnlewis.com/static/assets/favicon/android-chrome-256x256.png"
      sizes="256x256"
    />
    <link
      rel="icon"
      href="https://www.johnlewis.com/static/assets/favicon/android-chrome-384x384.png"
      sizes="384x384"
    />
    <link
      rel="icon"
      href="https://www.johnlewis.com/static/assets/favicon/android-chrome-512x512.png"
      sizes="512x512"
    />
  </>
);
